import axios, { AxiosRequestConfig, Canceler } from 'axios'
import Cookies from 'js-cookie'
import { ElMessage } from 'element-plus'
import { responseData } from '../axios'
import urlConfig from '@/services/urlConfig'
import { store } from '@/store'

const portal = axios.create({
	baseURL: urlConfig.httpRequestUrl,
	timeout: 900000,
	responseType: "json",//请求数据类型包括  'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
	withCredentials: false,//表示跨域请求时是否需要使用凭证,是true的时候，开启withCredentials后，服务器才能拿到你的cookie，当然后端服务器也要设置允许你获取你开启了才有用
})

const pending: { url: string; cancel: Canceler }[] = []
const cancelToken = axios.CancelToken

//处理重复请求
const addPending = (config: AxiosRequestConfig) => {
	const url = config.url + '&' + config.method + '&' + config.data
	config.cancelToken = new cancelToken(cancel => {
		if (!pending.some(item => item.url === url)) {
			pending.push({
				url,
				cancel
			})
		}
	})
}
// 取消请求
const removePending = (config: AxiosRequestConfig) => {
	const url = config.url + '&' + config.method + '&' + config.data
	pending.forEach((item, index) => {
		if (item.url === url) {
			item.cancel('取消重复请求:' + config.url)
			pending.splice(index, 1)
		}
	})
}

//请求拦截器
portal.interceptors.request.use(
	(config: AxiosRequestConfig) => {
		const token = store.state.portal.portalToken || Cookies.get('portal-token') || '';
		if (token) {
			config.headers.token = token
		}
		removePending(config)
		addPending(config)
		return config
	},
	error => Promise.reject(error)
)

//请求结束&&loading=false
const requestEnd = (config = {}) => {
	removePending(config)
}

//响应拦截器
portal.interceptors.response.use(
	response => {
		const { config } = response
		requestEnd(config)
		return Promise.resolve(response)
	},
	error => {
		return Promise.reject(error)
	}
)

/**
 * post，主要用于代码提示
 * @param url [请求的url地址]
 * @param params [请求时携带的参数]
 * @param showError [显示错误]
 */

const post = <t>(url: string, params?: object, showError = true): Promise<t> =>
	portal.post(url, params).then(res => {
		const responseData = res.data as responseData<t>;
		if (responseData.status === 1 || responseData.status === 200) {
			const data = responseData.data as t;
			return Promise.resolve(data);
		}
		// 后端接口通了，但是报错
		if (showError) {
			ElMessage({ type: "error", message: responseData.message });
		}
		return Promise.reject(responseData);
	}).catch(e => Promise.reject(e));

/*
 * get
 * @param url 请求地址
 * @param params 请求参数
 * */
const get = <t>(url: string, params?: object, showError = true): Promise<t> =>
	portal.get(url, { params }).then(res => {
		const responseData = res.data as responseData<t>;
		if (responseData.status === 1 || responseData.status === 200) {
			const data = responseData.data as t;
			return Promise.resolve(data);
		}
		if (showError) {
			ElMessage({ type: "error", message: responseData.message });
		}
		return Promise.reject(responseData);
	}).catch(e => Promise.reject(e));

export default {
	post,
	get
}
